// Auto-generated skeleton for BuildingGroup

import { BuildingType } from "./BuildingType";

export const BuildingGroup: Api.BuildingGroup = {
  id: 0,
  hp_id: 0,
  building_type_id: 0,
  building_type: BuildingType,
  name: '',
  created: null,
  updated: null,
};

